import React, {useState, useRef} from 'react';
import styles from './ButtonWithHoverEffect.module.css';

const ButtonWithHoverEffect = ({url, referralCode}) => {
    const [gradientStyle, setGradientStyle] = useState({
        background: 'radial-gradient(circle at 0% 0%, #ffffff 0%, #6CE3C4 80%, #6CE3C4 100%)',
    });

    const buttonRef = useRef(null);

    const xPercentRef = useRef(0);
    const yPercentRef = useRef(0);

    const color1 = '#6CE3C4';
    const color2 = '#6CE3C4';
    const color3 = '#ffffff';

    const animateBackToCenter = useRef(false);
    const animationFrameId = useRef(null);

    const setGradient = (xPerc, yPerc) => {
        const gradient = `radial-gradient(circle at ${xPerc}% ${yPerc}%, ${color3} 0%, ${color2} 80%, ${color1} 100%)`;
        setGradientStyle({background: gradient});
    };

    const handleMouseMove = (e) => {
        if (animateBackToCenter.current) {
            cancelAnimationFrame(animationFrameId.current);
            animateBackToCenter.current = false;
        }

        const button = buttonRef.current;
        const rect = button.getBoundingClientRect();

        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const xPercent = (x / rect.width) * 100;
        const yPercent = (y / rect.height) * 100;

        xPercentRef.current = xPercent;
        yPercentRef.current = yPercent;
        setGradient(xPercent, yPercent);
    };

    const handleMouseLeave = () => {
        animateBackToCenter.current = true;

        const startX = xPercentRef.current;
        const startY = yPercentRef.current;

        const distance = Math.sqrt(startX * startX + startY * startY);

        const baseEasing = 0.1;
        const easing = baseEasing / (1 + distance / 50);

        const animate = () => {
            if (!animateBackToCenter.current) return;
            const currentX = xPercentRef.current;
            const currentY = yPercentRef.current;

            const targetX = 0;
            const targetY = 0;

            const newX = currentX + (targetX - currentX) * easing;
            const newY = currentY + (targetY - currentY) * easing;

            xPercentRef.current = newX;
            yPercentRef.current = newY;

            setGradient(newX, newY);

            if (Math.abs(newX - targetX) < 0.5 && Math.abs(newY - targetY) < 0.5) {
                xPercentRef.current = 0;
                yPercentRef.current = 0;
                setGradient(0, 0);
                animateBackToCenter.current = false;
                return;
            }

            animationFrameId.current = requestAnimationFrame(animate);
        };

        animationFrameId.current = requestAnimationFrame(animate);
    };

    const handleClick = () => {
  if (referralCode) {
    const url = `https://app.kira.trading?ref=${referralCode}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};

    return (
        <button
            ref={buttonRef}
            className={styles.button}
            style={gradientStyle}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
        >
            Earn Free Interest Now
        </button>
    );
};

export default ButtonWithHoverEffect;
